import * as _ from 'lodash';
import './missionGroup.less';

import { CalendarPosition } from '../misc/calendarPosition';

angular.module("tromanWeb").controller('MissionGroupMissionsController', ['stateService', 'tromanServer', 'dialogService', 'missionGroupShared', function (stateService, tromanServer, dialogService, missionGroupShared) {

    const missionGroupId = missionGroupShared.missionGroup.Id;

    this.$onInit = function $onInit() {
        const params = stateService.getParams();

        this.filter = params.filter;

        tromanServer.Missions
            .search({ MissionGroupId: missionGroupId })
            .then(data => {
                this.missions = data;
                this.error = null;
            })
            .catch(err => {
                this.missions = null;
                this.error = err;
            });
    };

    this.uiOnParamsChanged = function (changed) {
        if (_.has(changed, 'filter')) {
            this.filter = changed.filter;
        }
    };

    this.filterChanged = function filterChanged() {
        stateService.replaceParams({ filter: this.filter });
    };

    this.getMissionClass = function (mission) {
        switch (mission.calendarPosition) {
            case CalendarPosition.Historic: return 'mission-historic';
            case CalendarPosition.Active: return 'mission-active';
            case CalendarPosition.Future: return 'mission-future';
        }
    };

    this.canCreateList = function canCreateList() {
        return this.table != null && this.table.selectionCount > 0;
    };

    this.createList = function createList() {
        if (!this.canCreateList()) return;

        var list = this.table.selectedItems();
        dialogService.createMissionList(list);
    };

    this.canCreateEmails = function canCreateEmails() {
        return this.table != null && this.table.selectionCount > 0;
    };

    this.createEmails = function createEmails() {
        if (!this.canCreateEmails()) return;

        var list = this.table.selectedItems().map(x => x.Person);
        dialogService.createEmailList(list);
    };

    this.canAddToMissionGroup = function canAddToMissionGroup() {
        return this.table != null && this.table.selectionCount > 0;
    };

    this.addToMissionGroup = function addToMissionGroup() {
        if (!this.canAddToMissionGroup()) return;

        var list = this.table.selectedItems();
        dialogService.addToMissionGroup(list, missionGroupId);
    };

    this.canRemoveItems = function canRemoveItems() {
        return this.table != null && this.table.selectionCount > 0;
    };

    this.removeItems = function removeItems() {
        if (!this.canRemoveItems()) return;

        var list = this.table.selectedItems();
        dialogService.confirm(`Ta bort ${list.length} uppdrag från plocklistan.`).then(() => {
            tromanServer.MissionGroups.removeFromMissionGroup(missionGroupId, list)
                .catch(dialogService.error)
                .finally(() => { stateService.reload(); });
        });
    };
}]);
